import { Action } from '@ngrx/store';
import { DiscountUX } from 'ops-discounts';
import { ManufacturerStepRequest, DiscountState, IWizardDelivery, BackOrderStepRequest } from '../reducers/new-claim-wizard.reducer';
import { IShop } from 'src/app/shared//services/shops.service';
import { IManufacturePart, IManufactureSettings } from 'src/app/shared/services/manufactures.service';

const BASE_ACTION = 'NEW_CLAIM_WIZARD_';
export const NEW_CLAIM_WIZARD_VALUES = 'NEW_CLAIM_WIZARD_VALUES';

export const INIT = `${BASE_ACTION}INIT`;
export const REMAIN_CURRENT_STATE = `${BASE_ACTION}REMAIN_CURRENT_STATE`;
export const SET_IS_VALID_WIZARD_STEP = `${BASE_ACTION}VALIDATE_WIZARD_STEP`;
export const UPDATE_WIZARD_STEP = `${BASE_ACTION}UPDATE_WIZARD_STEP`;
export const SET_MANUFACTURERS = `${BASE_ACTION}SET_MANUFACTURERS`;
export const SET_DISCOUNT_UX = `${BASE_ACTION}SET_DISCOUNT_UX`;
export const SET_MAKE_ID = `${BASE_ACTION}SET_MAKE_ID`;
export const SET_SHOP = `${BASE_ACTION}SET_SHOP`;
export const SET_VALIDATION_MSG = `${BASE_ACTION}SET_VALIDATION_MSG`;
export const SET_ACCOUNT_EMAIL = `${BASE_ACTION}SET_ACCOUNT_EMAIL`;
export const SET_DISCOUNT = `${BASE_ACTION}SET_DISCOUNT`;
export const SET_VIN = `${BASE_ACTION}SET_VIN`;
export const SET_MANUFACTURE_SETTINGS = `${BASE_ACTION}SET_MANUFACTURE_SETTINGS`;
export const SET_CLAIM_PARTS = `${BASE_ACTION}SET_CLAIM_PARTS`;
export const SET_ORDER_TYPE = `${BASE_ACTION}SET_ORDER_TYPE`;
export const SET_WARNING_FLAGS = `${BASE_ACTION}SET_WARNING_FLAGS`;
export const SET_DELIVERY = `${BASE_ACTION}SET_DELIVERY`;
export const SET_REFRENCE_ID = `${BASE_ACTION}SET_REFRENCE_ID`;
export const SET_CLAIM_PARTS_AND_DELIVERY = `${BASE_ACTION}SET_CLAIM_PARTS_AND_DELIVERY`;
export const SET_COMPLETED = `${BASE_ACTION}SET_COMPLETED`;

export const RESTORE_WIZARD_DATA = `${BASE_ACTION}RESTORE_WIZARD_DATA`;
export const SAVE_ON_LS = `${BASE_ACTION}SAVE_ON_LS`;

export class Init implements Action {
  readonly type = INIT;

  constructor(public payload: any) { }
}

export class SetIsValidWizardStep implements Action {
  readonly type = SET_IS_VALID_WIZARD_STEP;

  constructor(public payload: boolean) { }
}

export class SetWizardStep implements Action {
  readonly type = UPDATE_WIZARD_STEP;

  constructor(public payload: number) { }
}

export class SetManufacturers implements Action {
  readonly type = SET_MANUFACTURERS;

  constructor(public payload: ManufacturerStepRequest) { }
}

export class SetDiscountUx implements Action {
  readonly type = SET_DISCOUNT_UX;

  constructor(public payload: DiscountUX) { }
}

export class SetMakeId implements Action {
  readonly type = SET_MAKE_ID;

  constructor(public payload: number) { }
}

export class SetShop implements Action {
  readonly type = SET_SHOP;

  constructor(public payload: IShop) { }
}

export class SetValidationMessage implements Action {
  readonly type = SET_VALIDATION_MSG;

  constructor(public payload: string) { }
}

export class SetAccountEmail implements Action {
  readonly type = SET_ACCOUNT_EMAIL;

  constructor(public payload: string) { }
}

export class SetDiscount implements Action {
  readonly type = SET_DISCOUNT;

  constructor(public payload: DiscountState) { }
}

export class SetVin implements Action {
  readonly type = SET_VIN;

  constructor(public payload: string) { }
}

export class SetManufactureSettings implements Action {
  readonly type = SET_MANUFACTURE_SETTINGS;

  constructor(public payload: IManufactureSettings) { }
}

export class SetClaimParts implements Action {
  readonly type = SET_CLAIM_PARTS;

  constructor(public payload: IManufacturePart[]) { }
}

export class SetOrderType implements Action {
  readonly type = SET_ORDER_TYPE;

  constructor(public payload: number) { }
}

export class SetWarningFlags implements Action {
  readonly type = SET_WARNING_FLAGS;

  constructor(public payload: string[]) { }
}

export class SetDelivery implements Action {
  readonly type = SET_DELIVERY;

  constructor(public payload: IWizardDelivery) { }
}

export class SetReferenceId implements Action {
  readonly type = SET_REFRENCE_ID;

  constructor(public payload: number) { }
}

export class SetClaimPartsAndDelivery implements Action {
  readonly type = SET_CLAIM_PARTS_AND_DELIVERY;

  constructor(public payload: BackOrderStepRequest) { }
}
export class SetCompleted implements Action {
  readonly type = SET_COMPLETED;

  constructor(public payload: boolean) { }
}


export class SetSaveOnLs implements Action {
  readonly type = SAVE_ON_LS;

  constructor(public payload: any) { }
}


export type NewClaimWizardActions =
  Init | SetIsValidWizardStep | SetWizardStep |
  SetManufacturers | SetDiscountUx | SetMakeId |
  SetShop | SetValidationMessage | SetAccountEmail |
  SetDiscount | SetVin | SetManufactureSettings |
  SetClaimParts | SetOrderType | SetWarningFlags |
  SetDelivery | SetReferenceId | SetCompleted |SetSaveOnLs;
